import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const LocationBillingGroupsShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

LocationBillingGroupsShow.query = gql`
  query GET_ONE($id: Int!) {
    locationBillingGroup(id: $id) {
      id
      created_at
      updated_at
    }
  }
`;

export default LocationBillingGroupsShow;
